/**
 * Parches de seguridad para mitigar vulnerabilidades conocidas
 * en Vue 2.7.16, vue-template-compiler 2.7.16 y Bootstrap 4.6.2
 */

// Patch para CVE-2024-6531: Bootstrap XSS en carousel component
// Sanitizar URLs en componentes carousel para prevenir XSS
function sanitizeCarouselUrls() {
    if (typeof document !== 'undefined') {
        // Interceptar clics en carousel items
        document.addEventListener('click', function (e) {
            if (e.target.closest('.carousel-item') || e.target.closest('[data-slide]')) {
                const href = e.target.getAttribute('href');
                if (href && (href.includes('javascript:') || href.includes('data:') || href.includes('vbscript:'))) {
                    e.preventDefault();
                    console.warn('Blocked potentially malicious carousel URL:', href);
                }
            }
        });
    }
}

// Aplicar sanitización de carousel
sanitizeCarouselUrls();

// Patch para CVE-2024-9506: ReDoS Vulnerability en Vue
// Este patch limita la longitud de los strings que pueden ser procesados por el parser HTML
if (typeof window !== 'undefined' && window.Vue) {
    const originalParseHTML = window.Vue.util.parseHTML;
    if (originalParseHTML) {
        window.Vue.util.parseHTML = function (html, options) {
            // Limitar la longitud del HTML para prevenir ReDoS
            if (typeof html === 'string' && html.length > 10000) {
                console.warn('HTML template muy largo, limitando por seguridad');
                html = html.substring(0, 10000);
            }
            return originalParseHTML.call(this, html, options);
        };
    }
}

// Función para sanitizar templates Vue
function sanitizeVueTemplate(template) {
    if (typeof template !== 'string') return template;

    // Remover scripts maliciosos
    template = template.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '');

    // Escapar caracteres peligrosos en expresiones
    template = template.replace(/\{\{([^}]+)\}\}/g, function (match, expression) {
        // Sanitizar expresiones que podrían ser maliciosas
        const sanitizedExpression = expression.replace(/[<>'"]/g, '');
        return '{{' + sanitizedExpression + '}}';
    });

    return template;
}

// Exportar funciones de seguridad
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        sanitizeVueTemplate
    };
}

// Hacer funciones disponibles globalmente para uso en consola
if (typeof window !== 'undefined') {
    window.securityPatches = {
        sanitizeVueTemplate
    };
}



console.log('Parches de seguridad aplicados para Vue 2.7.16, vue-template-compiler 2.7.16 y Bootstrap 4.6.2');